<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="calc-form">
    <el-form-item
      v-if="userType === '1' || userType === '2' || userType === '3'"
      :label="userType !== '2' ? $t('cliente') : $t('filial')"
      prop="customer"
    >
      <CustomerList v-model="ruleForm.customer" :customerType="userType === '1' ? 0 : 1" v-on:selected="selected" />
    </el-form-item>
    <el-row :gutter="5">
      <el-col :span="12">
        <el-form-item :label="$t('cep-origem')" prop="name" class="is-required">
          <el-input maxlength="9" v-model="ruleForm.source" v-mask="'#####-###'"
            @input="autoSource = false"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('cep-destino')" prop="active" class="is-required">
          <el-input maxlength="9" v-model="ruleForm.destiny" v-mask="'#####-###'"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :span="5">
        <el-form-item :label="$t('altura')" prop="name">
          <el-input maxlength="80" v-model="ruleForm.height">
            <template slot="append">cm</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item :label="$t('largura')" prop="active">
          <el-input maxlength="80" v-model="ruleForm.width">
            <template slot="append">cm</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item :label="$t('comprimento')" prop="active">
          <el-input maxlength="80" v-model="ruleForm.length">
            <template slot="append">cm</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item :label="$t('peso-g')" prop="active" class="is-required">
          <el-input maxlength="80" v-model="ruleForm.weight">
            <template slot="append">g</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item :label="$t('valor')" prop="active">
          <el-input maxlength="80" v-model="ruleForm.value">
            <template slot="prepend">R$</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" type="flex" align="middle">
      <el-col :span="10">
        <el-form-item class="calc-form__inline-item">
          <el-checkbox v-model="ruleForm.warning">Aviso Recebimento (A.R. ou A.R-E)</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item class="calc-form__inline-item">
          <el-checkbox v-model="ruleForm.ownhand">Mãos Próprias (M.P.)</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6" style="text-align: right">
        <el-form-item class="calc-form__inline-item">
          <el-button plain size="small" icon="el-icon-search" class="calc-submit" autofocus
            @click="submitForm('ruleForm')">{{ $t("calcular") }}</el-button>
        </el-form-item>
      </el-col>
    </el-row>
    <el-alert
      v-if="ruleForm.warning || ruleForm.ownhand"
      :closable="false"
      type="warning"
      show-icon
      description="Os serviços adicionais A.R - A.R-Eletrônico e MP - Mão própria - Não estão disponíveis para os serviços EXPRESSO 1 e ECONOMICO 1."
    />
  </el-form>
</template>

<script>
import CalculateHistory from "./CalculateHistory.vue";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import { ValuesPrepostService } from "@/services/customers/values.prepost.services";
import { CustomerService } from "@/services/customers/customers.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "CalculateForm",
  props: {
    userType: { type: String, default: "1" },
    resultInModal: { type: Boolean, default: false },
  },
  data() {
    return {
      autoSource: false,
      ruleForm: {
        source: "",
        destiny: "",
        // Mínimos dos Correios (mesma régua dos mínimos de serviço da pré)
        length: 16,
        weight: 100,
        width: 11,
        height: 2,
        value: 0,
        warning: false,
        ownhand: false,
        customer: "",
      },
    };
  },
  mounted() {
    localStorage.removeItem("QUOTATION");
    const vm = this;
    UserService.me()
      .then((user) => {
        if (user.customers && user.customers.id) {
          vm.prefillSource(user.customers.id);
        }
      })
      .catch(() => {
        // sem prefill — o campo segue manual
      });
  },
  methods: {
    selected(customer) {
      this.ruleForm.customer = customer;
      this.$emit("change", customer);
      this.prefillSource(customer);
    },
    prefillSource(customer) {
      const vm = this;
      if (!customer) {
        return;
      }
      CustomerService.get(customer)
        .then((response) => {
          const zipcode = response && response.zipcode && response.zipcode.zipcode;
          if ((vm.autoSource || !vm.ruleForm.source) && zipcode) {
            vm.ruleForm.source = zipcode;
            vm.autoSource = true;
          }
        })
        .catch(() => {
          // cliente sem endereço principal: campo fica como está
        });
    },
    submitForm() {
      const vm = this;
      const data = {
        sourceZipcode: vm.ruleForm.source,
        destinyZipcode: vm.ruleForm.destiny,
        weight: +vm.ruleForm.weight,
        customer: this.ruleForm.customer,
        branch: "",
        warning: false,
        ownhand: vm.ruleForm.ownhand,
        digital: vm.ruleForm.warning,
        length: vm.ruleForm.length,
        width: vm.ruleForm.width,
        height: vm.ruleForm.height,
        valuedeclared: vm.ruleForm.value,
      };
      const loading = vm.$loading(vm.$options.loading);
      ValuesPrepostService.values(data)
        .then((response) => {
          if (response.error) {
            return this.$message({
              type: "error",
              duration: 5000,
              message: response.message,
            });
          }
          localStorage.setItem("QUOTATION_FORM", JSON.stringify(data));
          localStorage.setItem("QUOTATION", JSON.stringify(response));
          if (vm.resultInModal) {
            vm.$emit("result");
          } else {
            this.$router.replace({ name: "calculadora.frete.resultado" });
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  components: { CalculateHistory, CustomerList },
};
</script>

<style>
/* Form compacto: menos ar entre rótulo e campo e entre linhas */
.calc-form .el-form-item {
  margin-bottom: 10px;
}

.calc-form .el-form-item__label {
  padding-bottom: 0;
  line-height: 22px;
  font-size: 12px;
  font-weight: 600;
  color: #606266;
}

.calc-form__inline-item {
  margin-bottom: 0 !important;
}

.calc-submit.el-button--primary.is-plain {
  background: #fff;
  border-color: #22418d;
  color: #22418d;
  min-width: 120px;
}

.calc-submit.el-button--primary.is-plain:hover,
.calc-submit.el-button--primary.is-plain:focus {
  background: rgba(34, 65, 141, 0.06);
  border-color: #22418d;
  color: #22418d;
}
</style>
